import { GroupActionTypes, AddGroups, ModifyGroups } from './ActionTypes';
import { Group } from 'NSwag/ServerClient/Client.nswag';

export const addGroups = (groups: Group[]): AddGroups => ({
    type: GroupActionTypes.AddGroups as GroupActionTypes.AddGroups,
    groups
});

export const modifyGroups = (groups: Group[]): ModifyGroups => ({
    type: GroupActionTypes.ModifyGroups as GroupActionTypes.ModifyGroups,
    groups
});

export type GroupAction = ReturnType<typeof addGroups | typeof modifyGroups >